import DriverProjectService from '@/services/requests/driverProjectService'
import VehicleProjectService from '@/services/requests/vehicleProjectService'
import ContractorProjectService from '@/services/requests/contractorProjectService'
export default {
  data() {
    return {
      projectFilterEnabled: true
    }
  },
  methods: {
    filterByContractor(listName, contractorId) {
      return this[listName].filter(record => {
        return record.contractor.id == contractorId
      });
    },
    // filtered = this.filterByProject(this.contractors, this.projectId, this.contractorProjects, "contractorId");
    filterByProject(list, projectId, filterList, key) {

      return list.filter(listItem => {
        return !!filterList.filter(filterItem => {
          return filterItem[key] == listItem.id && filterItem.projectId == projectId
        }).length;
      });
    },

    // filterArrayByContractor(array, contractorId) {
    //   return array.filter(record => {
    //     return record.contractor.id == contractorId
    //   });
    // },
    // async filterDriverListByProject(array, projectId) {
    //   return array.filter(item => {
    //     return !!this.driverProjects.filter(project => {
    //       return project.driverId == item.id && project.projectId == projectId
    //     }).length;
    //   });
    // },
    // async filterVehicleListByProject(array, projectId) {
    //   return array.filter(item => {
    //     return !!this.vehicleProjects.filter(project => {
    //       return project.vehicleId == item.id && project.projectId == projectId
    //     }).length;
    //   });
    // },

    // getVehicleId() {
    //   var vehicleId = null
    //   if (!!this.site) {
    //     vehicleId = this.site.vehicleId
    //   } else if (!!this[this.prefix].site) {
    //     vehicleId = this[this.prefix].site.vehicleId
    //   } else if (!!this[this.prefix].docket) {
    //     vehicleId = this[this.prefix].docket.site.vehicle.id
    //   } else if (!!this[this.prefix]) {
    //     if (!!this[this.prefix].vehicle) {
    //       vehicleId = this[this.prefix].vehicle.id
    //     } else {
    //       vehicleId = this[this.prefix].vehicleId
    //     }
    //   } else {
    //     vehicleId = this.vehicleId
    //   }
    //   return vehicleId
    // },
    // getDriverId() {
    //   var driverId = null
    //   if (!!this.site) {
    //     driverId = this.site.driverId
    //   } else if (!!this[this.prefix].site) {
    //     driverId = this[this.prefix].site.driverId
    //   } else if (!!this[this.prefix].docket) {
    //     driverId = this[this.prefix].docket.site.driver.id
    //   } else if (!!this[this.prefix]) {
    //     if (!!this[this.prefix].driver) {
    //       driverId = this[this.prefix].driver.id
    //     } else {
    //       driverId = this[this.prefix].driverId
    //     }
    //   } else {
    //     driverId = this.driverId
    //   }
    //   return driverId
    // }
  },
  computed: {
    filteredDrivers() {
      let filtered = [];
      if (!!this.contractorId) {
        filtered = this.filterByContractor("drivers", this.contractorId);
      } else {
        filtered = this.drivers;
      }
      // var projectId = null
      if (!!this.projectId && this.projectFilterEnabled) {
        return this.filterByProject(filtered, this.projectId, this.driverProjects, "driverId");
      } else {
        return filtered
      }
    },
    filteredVehicles() {
      let filtered = [];
      if (!!this.contractorId) {
        filtered = this.filterByContractor("vehicles", this.contractorId);
      } else {
        filtered = this.vehicles;
      }
      // var projectId = null
      if (!!this.projectId && this.projectFilterEnabled) {
        return this.filterByProject(filtered, this.projectId, this.vehicleProjects, "vehicleId");
      } else {
        return filtered
      }
    },
    filteredContractors() {
      let filtered = []
      if (!!this.projectId && this.projectFilterEnabled) {
        // filtered = this.filterContractorListByProject(
        //   this.contractors,
        //   this.projectId
        // );
        filtered = this.filterByProject(this.contractors, this.projectId, this.contractorProjects, "contractorId");
      } else {
        return this.contractors;
      }
      return filtered
    },
    // getProjectId() {
    //     //var comp = !!this[this.prefix] ? this[this.prefix].site : null
    //     //console.log('getProject: ', this.prefix, comp);

    //     var projectId = this.projectId
    //     if(!!this.site) {
    //         console.log('Using Site/ProjectId');
    //         projectId = this.site.projectId
    //     } else if (!!this[this.prefix].site) {

    //         if(!!this[this.prefix].site.project) {
    //             console.log('Using Prefix/Site/Project.id');
    //             projectId = this[this.prefix].site.project.id
    //         } else {
    //             console.log('Using Prefix/Site/ProjectId');
    //             projectId = this[this.prefix].site.projectId
    //         }
    //     } else if (!!this[this.prefix].docket) {
    //         console.log('Using Prefix/Docket/Site/Project.id');
    //         projectId = this[this.prefix].docket.site.project.id
    //     } else {
    //         console.log('Using Prefix/ProjectId');
    //         this[this.prefix].projectId
    //     }
    //     return projectId
    // },
    driverObj() {
      // var id = this.getDriverId()
      var id = this.driverId
      if (!!this.drivers.length) {
        var result = this.drivers.filter(obj => {
          //console.log(id, obj.id)
          return obj.id === id
        })
        return result[0];
      }
      return null;
    },
    vehicleObj() {
      // var id = this.getVehicleId()
      var id = this.vehicleId
      if (!!this.vehicles.length) {
        var result = this.vehicles.filter(obj => {
          return obj.id === id
        })
        return result[0];
      }
      return null;

    },
    //FILTERING DRIVERS AND VEHICLES BY CONTRACTOR. THESE ARRAY PRPOPS ARE USED DIRECTLY IN TEMPLATE

  },
  asyncComputed: {
    driverProjects: {
      default: [],
      get() {
        if (!this.projectId) {
          return [];
        }
        return DriverProjectService.getDriverProjectsByProject(this.projectId)
          .then(result => {
            return result.data.result;
          })
          .catch(err => {
            this.snackError();
            console.log(err);
            return [];
          });
      }
    },
    vehicleProjects: {
      default: [],
      get() {
        if (!this.projectId) {
          return [];
        }
        return VehicleProjectService.getVehicleProjectsByProject(this.projectId)
          .then(result => {
            return result.data.result;
          })
          .catch(err => {
            this.snackError();
            console.log(err);
            return [];
          });
      }
    },
    contractorProjects: {
      default: [],
      get() {
        if (!this.projectId) {
          return [];
        }
        return ContractorProjectService.getContractorProjectsByProject(this.projectId)
          .then(result => {
            console.log(result.data.result)
            return result.data.result;
          })
          .catch(err => {
            this.snackError();
            console.log(err);
            return [];
          });
      }
    },
    // async filteredDrivers() {
    //     var firstList = []
    //     var secondList = []
    //     var projectId = !!this.currentProject ? this.currentProject.id : null
    //     if (!!projectId) {
    //         firstList = await this.filterDriverListByProject(this.drivers, projectId)
    //     } else {
    //         // firstList = this.drivers
    //         firstList = []
    //     }
    //     if (!!this.contractorId) {
    //         secondList = await this.filterArrayByContractor(firstList, this.contractorId)
    //     } else {
    //         secondList = firstList
    //     }
    //     return !projectId && !this.contractorId ? firstList : secondList 
    // },
    // async filteredVehicles() {
    //   var firstList = []
    //   var secondList = []
    //   //var projectId = !!this.currentProject ? this.currentProject.id : null
    //   if (!!this.projectId) {
    //     firstList = await this.filterVehicleListByProject(this.vehicles, projectId)
    //   } else {
    //     firstList = this.vehicles
    //   }
    //   if (!!this.contractorId) {
    //     secondList = await this.filterByContractor('vehicles', this.contractorId)
    //   } else {
    //     secondList = firstList;
    //   }
    //   return !projectId && !this.contractorId ? firstList : secondList
    // },
  },
  watch: {
    contractors(val) {
      if (!!val.length) {
        var filteredContractors = val.filter(record => {
          return record.id == null
        })
        if (!filteredContractors.length) {
          this.contractors.unshift({ name: "All", id: null })
        }


      }
    }
  },
  mounted() {

    this.$watch(`driverObj.id`, function (val) {
      if (!!val) {
        this.contractorId = this.driverObj.contractorId;
      }
    })
    this.$watch(`vehicleObj.id`, function (val) {
      if (!!val) {
        this.contractorId = this.vehicleObj.contractorId;
      }
    })
  }
}